// extracted by mini-css-extract-plugin
export var closeButton = "_gv-2";
export var closeButtonIcon = "_gv-3";
export var lightboxContent = "_gv-1";
export var lightboxOverlay = "_gv-0";